module.exports = __webpack_public_path__ + "img/BG_darkBlue.de5ad642.jpg";